import React, { useEffect, useState } from 'react';
import { DollarSign, ShoppingCart, Users, BarChart } from 'lucide-react';

const FinaceSummaryCards = ({ data }) => {
    const [cardWidth, setCardWidth] = useState('100%');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width >= 1024) {
                setCardWidth('calc(25% - 12px)');
            } else if (width >= 768) {
                setCardWidth('calc(50% - 12px)');
            } else {
                setCardWidth('100%');
            }
        };

        handleResize(); // Initial call
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const cardBase = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        borderRadius: '16px',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        transition: 'transform 0.3s ease',
        boxSizing: 'border-box',
        borderLeft: '4px solid',
        cursor: 'pointer',
    };

    const iconWrapper = {
        padding: '12px',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    const textStyle = {
        fontSize: '14px',
        color: '#4B5563',
        fontWeight: 600,
        marginBottom: '4px',
        textTransform: 'uppercase',
    };

    const numberStyle = {
        fontSize: '28px',
        fontWeight: 700,
    };

    const cards = [
        {
            label: 'Product Revenue',
            value: `KWD ${data.productRevenue?.toLocaleString() || 0}`,
            bg: '#F0F9FF',
            border: '#0EA5E9',
            icon: <ShoppingCart color="#0369A1" size={28} />,
            iconBg: '#BAE6FD',
            textColor: '#0369A1',
        },
        {
            label: 'Class Revenue',
            value: `KWD ${data.classRevenue?.toLocaleString() || 0}`,
            bg: '#F0FDF4',
            border: '#16A34A',
            icon: <Users color="#047857" size={28} />,
            iconBg: '#BBF7D0',
            textColor: '#047857',
        },
        {
            label: 'Subscription Revenue',
            value: `KWD ${data.subscriptionRevenue?.toLocaleString() || 0}`,
            bg: '#FEFCE8',
            border: '#CA8A04',
            icon: <DollarSign color="#A16207" size={28} />,
            iconBg: '#FEF08A',
            textColor: '#A16207',
        },
        {
            label: 'Available Balance',
            value: `KWD ${data.merchantBalance?.toLocaleString() || 0}`,
            bg: '#F3F4F6',
            border: '#6B7280',
            icon: <BarChart color="#374151" size={28} />,
            iconBg: '#D1D5DB',
            textColor: '#374151',
        },
    ];

    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                width: '100%',
                marginBottom: '20px',
            }}
        >
            {cards.map((card, index) => (
                <div
                    key={index}
                    style={{
                        ...cardBase,
                        backgroundColor: card.bg,
                        borderLeftColor: card.border,
                        width: cardWidth,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                >
                    <div>
                        <div style={textStyle}>{card.label}</div>
                        <div style={{ ...numberStyle, color: card.textColor }}>{card.value}</div>
                    </div>
                    <div style={{ ...iconWrapper, backgroundColor: card.iconBg }}>{card.icon}</div>
                </div>
            ))}
        </div>
    );
};

export default FinaceSummaryCards;
